import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import SiteNotice from "./SiteNotice";

export default function Layout({ children }) {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);

    return (
        <div
            className="flex min-h-screen flex-col bg-brand-offwhite text-brand-charcoal"
            data-testid="app-layout"
        >
            <SiteNotice />
            <Header />
            <main className="flex-1" data-testid="main-content">
                {children}
            </main>
            <Footer />
        </div>
    );
}
